import Vue from "vue";
import { findInFormAnswer } from "./find_in_form_answer.js";

export class MatrixFormInput {
  constructor(data, special_type) {
    this.type = "matrix";
    this.special_type = special_type;
    this.data = data || {
      required: false,
      topic: "",
      question: "",
      answers: [{ text: "" }, { text: "" }, { text: "" }],
      levels: [{ text: "" }, { text: "" }, { text: "" }],
    };
  }
}

export let MatrixFormInputComponent = Vue.extend({
  props: ["input"],
  template: "#matrix-form-input-template",
  data: function () {
    return {
      uuid: generateUUID(),
      trainee_answer: {},
      is_template: true,
    };
  },
  methods: {
    deleteAnswer: onDeleteAnswer,
    addAnswer: onAddAnswer,
    deleteLevel: onDeleteLevel,
    addLevel: onAddLevel,
    checkAnswer: onCheckAnswer,
  },
  created: function () {
    this.is_template = this.$attrs.is_template;
    const answer = findInFormAnswer(this.input);
    if (answer !== undefined) {
      this.trainee_answer = answer;
      let vm = this;
      _.defer(function () {
        updateChecked(vm.trainee_answer, vm.uuid);
      });
      this.$forceUpdate();
    }
  },
  watch: {
    trainee_answer: function () {
      this.$root.onTraineeAnswer(this);
    },
  },
});

// `answerKey` is the matrix row's stable uuid when present, falling back to the
// positional index (as a string) for legacy matrices created before uuids.
function onCheckAnswer(answerKey, levelIndex) {
  this.trainee_answer[answerKey] = levelIndex;
  updateChecked(this.trainee_answer, this.uuid);
}

function updateChecked(trainee_answer, uuid) {
  const currentMatrix = document.querySelector(`.js-matrix-form-input[data-uuid='${uuid}']`);
  currentMatrix.querySelectorAll(".js-checkable").forEach((checkbox) => {
    const indexLevel = parseInt(checkbox.dataset.indexLevel);
    const answerKey = checkbox.dataset.answerKey;
    checkbox.checked = trainee_answer[answerKey] === indexLevel;
  });
}

function onAddAnswer() {
  this.input.data.answers.push({ text: "" });
}

function onDeleteAnswer(index) {
  this.input.data.answers.splice(index, 1);
}

function onAddLevel() {
  this.input.data.levels.push({ text: "" });
}

function onDeleteLevel(index) {
  this.input.data.levels.splice(index, 1);
}

function generateUUID() {
  return ("0000" + ((Math.random() * Math.pow(36, 4)) << 0).toString(36)).slice(-4);
}
